import * as React from 'react';
import * as I18n from 'i18n-js';
import * as classNames from 'classnames';
import Tooltip from './tooltip';

interface IProps {
  preferredSeller: boolean;
  quickResponder: boolean;
  quickShipper: boolean;
  withCaptions?: boolean;
  smallBadges?: boolean;
}

export default class ShopBadges extends React.Component<IProps, null> {
  hasNoBadges() {
    return (
      !this.props.preferredSeller &&
      !this.props.quickShipper &&
      !this.props.quickResponder
    );
  }

  renderPreferredSeller() {
    if (!this.props.preferredSeller) { return null; }

    return (
      <Tooltip text={I18n.t('commons.shopBadges.preferredSellerDescription')} type="plain" stopPropagation>
        <button
          className="shared-shop-badge shared-shop-badge--preferred-seller"
          type="button"
          aria-label={I18n.t('commons.shopBadges.preferredSeller')}
        >
          <span>
            {I18n.t('commons.shopBadges.preferredSeller')}
          </span>
        </button>
      </Tooltip>
    );
  }

  renderQuickResponder() {
    if (!this.props.quickResponder) { return null; }

    return (
      <Tooltip text={I18n.t('commons.shopBadges.quickResponderDescription')} type="plain" stopPropagation>
        <button
          className="shared-shop-badge shared-shop-badge--quick-responder"
          type="button"
          aria-label={I18n.t('commons.shopBadges.quickResponder')}
        >
          <span>
            {I18n.t('commons.shopBadges.quickResponder')}
          </span>
        </button>
      </Tooltip>
    );
  }

  renderQuickShipper() {
    if (!this.props.quickShipper) { return null; }

    return (
      <Tooltip text={I18n.t('commons.shopBadges.quickShipperDescription')} type="plain" stopPropagation>
        <button
          className="shared-shop-badge shared-shop-badge--quick-shipper"
          type="button"
          aria-label={I18n.t('commons.shopBadges.quickShipper')}
        >
          <span>
            {I18n.t('commons.shopBadges.quickShipper')}
          </span>
        </button>
      </Tooltip>
    );
  }

  render() {
    if (!this.props || this.hasNoBadges()) { return null; }
    const classes = classNames(
      'shared-shop-badges',
      { 'shared-shop-badges--with-captions': this.props.withCaptions },
      { 'shared-shop-badges--small': this.props.smallBadges },
    );

    return (
      <div className={classes}>
        {this.renderPreferredSeller()}
        {this.renderQuickResponder()}
        {this.renderQuickShipper()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/shop_badges.tsx